import { createReducer, INITIAL_STATE } from '@shared/redux';

import { CONVERSION_TYPES } from '@shared/constants/overview/ConversionsTypesConstant';
import { DEFAULT_METRICS } from '@shared/constants/MetricsTypeConstants';
import { ColorConstants } from '@shared/constants';
import { subDays } from '@shared/wrappers/date/date';
import { PERIOD_FIELDS } from '@shared/constants/Segmented.constants';
import { SegmentedsAggregations } from '../segmented';
import { DashboardFiltersProps, GetDate } from './dashboard-filters.types';
import { calculatePreviousPeriod } from './dashboard-filter.utils';

export const CHANGE_DASHBOARD_FILTER = '@dashboard/filters/CHANGE_DASHBOARD_FILTER';
export const SET_INITIAL_DASHBOARD_FILTER = '@dashboard/filters/SET_INITIAL_DASHBOARD_FILTER';
export const GET_INITIAL_DASHBOARD_FILTERS = '@dashboard/filters/GET_INITIAL_DASHBOARD_FILTERS';

export const getDashboardFilters = state => state?.dashboard?.dashboardFilters;

// mover para utils
export const getStartDateFromDate: GetDate = ({ ranges }) => ranges?.date?.startDate;
export const getEndDateFromDate: GetDate = ({ ranges }) => ranges?.date?.endDate;

export const getDateRanges = state => state.dashboard.dashboardFilters.ranges?.date;

export const getDatesFromComparison = (state) => {
    const {
        startDate,
        endDate,
    } = state.dashboard.dashboardFilters?.ranges?.comparisonDate || {
        startDate: null,
        endDate: null,
    };

    const {
        startDateForComparison,
        endDateForComparison,
    } = calculatePreviousPeriod(state.dashboard.dashboardFilters.ranges.date);

    return {
        startDateForComparison: startDate || startDateForComparison,
        endDateForComparison: endDate || endDateForComparison,
    };
};

export const getStartDateFromComparison: GetDate = (
    { ranges },
) => ranges?.comparisonDate?.startDate;

export const getEndDateFromComparison: GetDate = ({ ranges }) => ranges?.comparisonDate?.endDate;

export const changeDashboardFilter = (params: Partial<DashboardFiltersProps>) => ({
    type: CHANGE_DASHBOARD_FILTER,
    payload: params,
});

export const setInitialDashboardFilters = (params: Partial<DashboardFiltersProps>) => ({
    type: SET_INITIAL_DASHBOARD_FILTER,
    payload: params,
});

export const getInitialDashboardFilters = () => ({
    type: GET_INITIAL_DASHBOARD_FILTERS,
    payload: {},
});

export const initialState = {
    error: null,
    ranges: {
        date: {
            startDate: subDays(new Date(), 30),
            endDate: subDays(new Date(), 1),
            key: 'date',
        },
    },
    conversionType: CONVERSION_TYPES.PURCHASE,
    segmentation: SegmentedsAggregations.Date,
    selectedCampaigns: [],
    metrics: {
        firstMetric: {
            isSelected: true,
            metric: { ...DEFAULT_METRICS.clicks, color: ColorConstants.FUN_BLUE },
        },
        secondMetric: {
            isSelected: true,
            metric: { ...DEFAULT_METRICS.cost, color: ColorConstants.FUN_GREEN },
        },
    },
    comparisonMetric: {
        firstMetric: {
            isSelected: true,
            metric: { ...DEFAULT_METRICS.clicks, color: ColorConstants.FUN_GREEN },
        },
        secondMetric: {
            isSelected: true,
            metric: {
                ...DEFAULT_METRICS.clicks,
                ...PERIOD_FIELDS.comparison_period,
                label: `Comparing ${DEFAULT_METRICS.clicks.label}`,
                color: ColorConstants.FUN_GREEN,
            },
        },
    },
    period: [],
};

const updateDashboardFilters = (state, action) => ({
    ...state,
    ...action.payload,
});

export const dashboardFiltersReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [CHANGE_DASHBOARD_FILTER]: updateDashboardFilters,
    [SET_INITIAL_DASHBOARD_FILTER]: updateDashboardFilters,
});
